import styled from 'styled-components';

export const OuterDiv = styled.div`
  display: flex;
  width: 100%;
  padding: 20px 0;
  box-sizing: border-box;
`;

export const OuterDivMobile = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const LeftDiv = styled.div`
  width: 100%;
  max-width: 400px;
  min-width: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;

  padding: 0 30px;
  box-sizing: border-box;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-top: 0px;
    padding: 0;
  }
`;

export const RightDiv = styled.div`
  width: 100%;
  overflow: auto;
`;

export const Header = styled.div`
  height: 16%;
  max-height: 150px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    height: 50px;
  }
`;
export const Body = styled.div`
  height: 84%;
  padding-top: 10px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    height: calc(100% - 65px);
  }
`;
